module.exports = __webpack_public_path__ + "media/DawsonPromoNew.3843c1af.mp4";